// LimiteErrori.tsx — se una schermata si rompe, niente pagina bianca: messaggio, segnalazione e "Ricarica".
import { Component, type ErrorInfo, type ReactNode } from "react";
import { Translation } from "react-i18next";
import { segnalaErrore } from "../servizi/errori.ts";

interface Stato {
  rotto: boolean;
}

export class LimiteErrori extends Component<{ children: ReactNode }, Stato> {
  override state: Stato = { rotto: false };

  static getDerivedStateFromError(): Stato {
    return { rotto: true };
  }

  override componentDidCatch(errore: Error, _info: ErrorInfo): void {
    segnalaErrore(errore);
  }

  override render(): ReactNode {
    if (!this.state.rotto) return this.props.children;
    return (
      <Translation>
        {(t) => (
          <div className="pagina schermata-semplice" role="alert">
            <p className="schermata-testo">{t("errore.titolo")}</p>
            <button type="button" className="pulsante pulsante-primario" onClick={() => window.location.reload()}>
              {t("errore.ricarica")}
            </button>
          </div>
        )}
      </Translation>
    );
  }
}
